import { ErrorStateMatcher } from "@angular/material";
import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";

export class CrossFieldErrorMatcher implements ErrorStateMatcher {
	constructor(private readonly errorCodes: string[]) { }

	public isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
		if (!!control && !!form) {
			if (control.invalid) {
				return true;
			}
			if (!!form.invalid) {
				for (const errorCode of this.errorCodes) {
					if (form.hasError(errorCode)) {
						return true;
					}
				}
			}
			return false;
		} else {
			return false;
		}
	}
}
